<div mat-dialog-header class="title">
	User
</div>
<div mat-dialog-content>
	<div class="flex-column">

		<mat-form-field>
			<mat-label>Permissions</mat-label>
			<mat-select [(ngModel)]="permissions" (selectionChange)="onPermissionsChanged()">
				<mat-option [value]="0">Standard</mat-option>
				<mat-option *ngIf="user.permissions>=1" [value]="1">Site Admin</mat-option>
				<mat-option *ngIf="user.permissions>=2" [value]="2">Client Admin</mat-option>
				<mat-option *ngIf="user.permissions>=3" [value]="3">Multi Client Admin</mat-option>
				<mat-option *ngIf="user.permissions>=4" [value]="4">Super Admin</mat-option>
			</mat-select>
		</mat-form-field>
		<div *ngIf="loadingClients" class="container centered-content">
			<mat-spinner strokeWidth="2" [diameter]="20"></mat-spinner>
		</div>
		<!-- Client Dropdown -->
		<mat-form-field *ngIf="!loadingClients">
			<mat-label>Client</mat-label>

			<!-- Single select -->
			<mat-select *ngIf="!isMultiClientMode" [(ngModel)]="client"
				(selectionChange)="onClientSelected($event.value)">
				<mat-option *ngFor="let c of (clients$ | async)" [value]="c">
					{{ c.name }}
				</mat-option>
			</mat-select>

			<!-- Multi select -->
			<mat-select *ngIf="isMultiClientMode" [(ngModel)]="selectedClientIds" multiple
				(selectionChange)="onMultiClientSelectionChange($event.value)">
				<mat-option *ngFor="let c of (clients$ | async)" [value]="c.id">
					{{ c.name }}
				</mat-option>
			</mat-select>
		</mat-form-field>
		<div *ngIf="loadingSites" class="container centered-content">
			<mat-spinner strokeWidth="2" [diameter]="20"></mat-spinner>
		</div>
			<mat-form-field *ngIf="siteDropdownVisible$ | async">
				<mat-label>Site</mat-label>
				<mat-select *ngIf="!loadingSites" [(ngModel)]="siteId">
					<mat-option *ngFor="let s of siteOptions" [value]="s.id">
						{{ s.name }}
				</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-form-field>
			<mat-label>First Name</mat-label>
			<input matInput type="text" [(ngModel)]="firstName" />
		</mat-form-field>

		<mat-form-field>
			<mat-label>Last Name</mat-label>
			<input matInput type="text" [(ngModel)]="lastName" />
		</mat-form-field>

		<mat-form-field>
			<mat-label>Email</mat-label>
			<input matInput type="text" [(ngModel)]="email" />
		</mat-form-field>

		<mat-form-field>
			<mat-label>Password</mat-label>
			<input matInput type="text" [(ngModel)]="password" />
		</mat-form-field>
	</div>
</div>
<div mat-dialog-actions>
	<button mat-button (click)="cancel()">Cancel</button>
	<button mat-flat-button color="primary" [disabled]="!valid()" (click)="save()">Save</button>
</div>
